import React, { useState } from 'react';
import { theme } from 'theme/MainTheme';
import { useTranslation } from 'react-i18next';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Fade from '@mui/material/Fade';
import Dialog from '@mui/material/Dialog';
import PlayerVideo from 'components/atoms/PlayerVideo/PlayerVideo';
import VideoLogin from 'assets/video/pierwsze-logowanie.mp4';
import VideoDownload from 'assets/video/pobieranie-zalacznikow.mp4';
import VideoForm from 'assets/video/formularz-zmiany-danych.mp4';

export default function Help({ btn }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [openModal, setOpenModal] = useState({ isOpen: false, video: '' });
  const open = Boolean(anchorEl);
  const { t } = useTranslation();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const showVideo = (e) => {
    const { src } = e.currentTarget.dataset;
    setOpenModal({ isOpen: true, video: src });
    handleClose();
  };

  const closeVideo = () => {
    setOpenModal({ isOpen: false });
  };

  const videos = [
    {
      id: 1,
      describe: t('first_login'),
      src: VideoLogin,
    },
    {
      id: 2,
      describe: t('help_attachments_download'),
      src: VideoDownload,
    },
    {
      id: 3,
      describe: t('help_form'),
      src: VideoForm,
    },
  ];
  return (
    <div>
      <Button
        id="basic-button"
        aria-controls={open ? 'fade-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        sx={{
          marginLeft: '3rem',
          fontSize: theme.fontSize.xs,
          backgroundColor: theme.primary,
          color: theme.white,
          margin: '0 25px 0 0',
          ':hover': {
            backgroundColor: theme.hover,
          },
        }}
      >
        {t('help')}
      </Button>
      <Menu
        id="fade-menu"
        MenuListProps={{
          'aria-labelledby': 'fade-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
      >
        {videos.map((video) => (
          <MenuItem key={video.id} onClick={showVideo} data-src={video.src} value={video.src}>
            {video.describe}
          </MenuItem>
        ))}
      </Menu>
      <Dialog
        open={openModal.isOpen}
        onClose={closeVideo}
        sx={{ '& .MuiPaper-root': { maxWidth: '1000px' } }}
      >
        <PlayerVideo videoSrc={openModal.video} />
      </Dialog>
    </div>
  );
}
